import { render, staticRenderFns } from "./VcaToolbox.vue?vue&type=template&id=ff445f76"
import script from "./VcaToolbox.vue?vue&type=script&lang=js"
export * from "./VcaToolbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports